import React from 'react'
import styled from 'styled-components'

interface ISvgProps {
  width?: number
  height?: number
  size?: number
}

const Svg = styled.svg<ISvgProps>`
  width: ${props => (props.size || props.width ? `${props.width ?? props.size}px` : '24px')};
  height: ${props => (props.size || props.height ? `${props.height ?? props.size}px` : '24px')};
`

interface ISvgIcon {
  children: React.ReactNode
  titleAccess?: string
  viewBox?: string
  size?: number
  width?: number
  height?: number
}

const SvgIcon = (props: ISvgIcon) => {
  const { children, titleAccess, viewBox = '0 0 24 24', ...other } = props

  return (
    <Svg
      focusable="false"
      viewBox={viewBox}
      aria-hidden={titleAccess ? 'false' : 'true'}
      role={titleAccess ? 'img' : 'presentation'}
      {...other}
    >
      {children}
      {titleAccess ? <title>{titleAccess}</title> : null}
    </Svg>
  )
}

export default SvgIcon
